// extracted by extract-css-chunks-webpack-plugin
module.exports = {"agreements-wrapper":"account__agreements-wrapper--2FF-Q","agreementsWrapper":"account__agreements-wrapper--2FF-Q"};